import { Url } from 'url';

export interface Dashboard {
    fila: number;
    posicion: number;
    objeto: number;
    visualizacion: number;
    imagen: Url;
    enlace: string;
    accion: any;
}

export class DashboardHelper {
    static create() {
        return {
            fila: 0,
            posicion: 0,
            objeto: 0,
            visualizacion: 0,
            imagen: '',
            enlace: '',
            accion: null,
        };
    }

    static transformFromApi(apiData: Object) {
        const object = DashboardHelper.create();
        object.fila = apiData['FILA'];
        object.posicion = apiData['POSICION'];
        object.objeto = apiData['OBJETO'];
        object.visualizacion = apiData['VISUALIZACION'];
        object.imagen = apiData['IMAGEN'];
        object.enlace = apiData['ENLACE'];
        object.accion = apiData['ACCION'];

        return object;
    }
}
